import { Injectable } from '@angular/core';
import { AutocompleteFunction } from '@stylehaven/components';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { AutocompleteRequest } from '../../entities/autocomplete/autocomplete-request.entity';
import { AutocompleteResponse } from '../../entities/autocomplete/autocomplete-response.entity';
import { MapObjectToHttpParams } from '../../helpers';
import { DottedKeyToFlatKey } from '../../helpers/dottedkey-to-flatkey.helper';
import { toFormSelectOption } from '../../helpers/form-select-option.helper';
import { AbstractHttpService } from '../http/http-service.abstract';

@Injectable()
export class AutocompleteService {
    constructor(private readonly http: AbstractHttpService) {}

    private readonly ENDPOINT: string = `autocomplete`;

    public getFieldAutocomplete(request: AutocompleteRequest): Observable<AutocompleteResponse[]> {
        if (request.input === undefined || request.input === '') {
            return of([]);
        }
        return this.http.get<AutocompleteResponse[]>(this.ENDPOINT, MapObjectToHttpParams(request));
    }

    public getFieldAutocompleteFunction(dottedKey: string): AutocompleteFunction {
        return query => {
            const search: AutocompleteRequest = {
                // Using flat key because property 'indexWide' does not work for predefined Descriptive.Keywords.Keyword field,
                // but does work for dynamic field KeywordsKeyword
                // See issue ENG-4465 for more info
                field: DottedKeyToFlatKey(dottedKey),
                input: query,
                indexWide: false
            };
            return this.getFieldAutocomplete(search).pipe(
                map(response => {
                    return {
                        options: response.map(value => toFormSelectOption(value.Term)),
                        isLiveData: false
                    };
                })
            );
        };
    }
}
